import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	Typography,
	DialogActions,
	styled
} from "@mui/material";
import ThemeButton from "components/Buttons/ThemeButton";
import { useGoogleAnalyticsContext } from "contexts";
import { useAppDispatch } from "hooks";
import { onDIPtrigger } from "redux/slices";
import CloseIconButton from "../lib/CloseIconButton";

const buttonStyles = {
	paddingTop: ".75rem",
	paddingBottom: ".75rem",
	marginBottom: 1,
	width: "calc(100% - 3rem)",
	marginLeft: 2,
	marginRight: 2
};

const ButtonContainer = styled("div")({
	width: "100%",
	paddingLeft: "16px"
});

const DialogLoginRewardConfirmation = ({
	show,
	onCloseClick
}: {
	show: boolean;
	onCloseClick: () => void;
}) => {
	const dispatch = useAppDispatch();
	const { reportEvent } = useGoogleAnalyticsContext();
	return (
		<Dialog
			open={show}
			onClose={() => {
				onCloseClick();
				dispatch(onDIPtrigger({ triggerType: "firstTimeLogin" }));
			}}
			sx={{
				".MuiPaper-root": {
					borderRadius: 6,
					paddingBottom: ".15rem",
					width: "462px"
				}
			}}
		>
			<DialogTitle
				sx={{
					// height: "199px",
					// padding: 0,
					// backgroundSize: "cover",
					// backgroundColor: "#3B2FC5",
					// backgroundImage: backgroundImage,
					// backgroundPosition: "center top",
					overflow: "hidden"
				}}
			>
				<CloseIconButton
					onClose={() => {
						onCloseClick();
						reportEvent("dialog_x_close", {
							source: "received_first_login_reward_confirmation_dialog"
						});
					}}
				/>
			</DialogTitle>
			<DialogContent sx={{ paddingBottom: 0 }}>
				<DialogContentText sx={{ padding: ".75rem 1rem" }}>
					<Typography
						variant="h6"
						component="strong"
						sx={{
							fontWeight: "bold",
							margin: "1rem 0 .75rem",
							display: "block",
							textAlign: "center",
							fontSize: "164%",
							lineHeight: 1,
							color: "#333333"
						}}
					>
						You’re Connected!
					</Typography>
					Your account is now connected to the web shop. Your welcome gift is
					now waiting to be collected in your in-game inbox.
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ justifyContent: "center", flexDirection: "column" }}>
				<ButtonContainer>
					<ThemeButton
						onClick={() => {
							onCloseClick();
							dispatch(onDIPtrigger({ triggerType: "firstTimeLogin" }));
							reportEvent("continue_shopping_click", {
								source: "received_first_login_reward_confirmation_dialog"
							});
						}}
						sx={{
							...buttonStyles
						}}
					>
						Continue to Shop
					</ThemeButton>
				</ButtonContainer>
			</DialogActions>
		</Dialog>
	);
};

export { DialogLoginRewardConfirmation };
